import { cn } from "@shared/lib/utils";
import { useSettingsStore } from "@shared/store/settings.store";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuGroup,
	DropdownMenuLabel,
	DropdownMenuRadioGroup,
	DropdownMenuRadioItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@shared/ui/dropdown-menu";
import { Separator } from "@shared/ui/separator";
import { SidebarMenuButton, SidebarTrigger } from "@shared/ui/sidebar";
import { Languages } from "lucide-react";
import { FormattedMessage } from "react-intl";
import Breadcrumbs from "./breadcrumbs";

export default function Header() {
	const { sidebarCollapsible, headerVariant, locale, setLocale } = useSettingsStore();

	return (
		<header
			className={cn(
				"flex h-16 shrink-0 top-0 left-0  items-center  gap-2 transition-[width,height] ease-linear group-has-data-[collapsible=icon]/sidebar-wrapper:h-12",
				{
					"bg-background sticky rounded-xl": headerVariant === "sticky",
				}
			)}
		>
			<div className="flex items-center gap-2 px-4  w-full">
				{sidebarCollapsible !== "none" && (
					<>
						<SidebarTrigger className="-ml-1" />
						<Separator
							orientation="vertical"
							className="mx-2 data-[orientation=vertical]:h-4 border"
						/>
					</>
				)}
				<Breadcrumbs />
				<DropdownMenu>
					<DropdownMenuTrigger asChild className="size-10 ml-auto">
						<SidebarMenuButton
							size="lg"
							className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground flex items-center justify-center"
						>
							<Languages className="size-5" />
						</SidebarMenuButton>
					</DropdownMenuTrigger>
					<DropdownMenuContent
						className="w-(--radix-dropdown-menu-trigger-width) min-w-40 rounded-lg"
						//side={isMobile ? "bottom" : "right"}
						align="end"
						sideOffset={4}
					>
						<DropdownMenuLabel className="p-0 font-normal">
							<div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
								<Languages />
								<div className="grid flex-1 text-left text-sm leading-tight">
									<span className="truncate font-medium">
										<FormattedMessage
											defaultMessage="Language"
											id="page.profile.settings.languageDescription"
										/>
									</span>
								</div>
							</div>
						</DropdownMenuLabel>
						<DropdownMenuSeparator />
						<DropdownMenuGroup>
							<DropdownMenuRadioGroup value={locale}>
								<DropdownMenuRadioItem
									className="cursor-pointer"
									value="ru"
									disabled={locale === "ru"}
									onSelect={() => setLocale("ru")}
								>
									<FormattedMessage
										defaultMessage="Russian"
										id="page.profile.settings.language.ru"
									/>
								</DropdownMenuRadioItem>
								<DropdownMenuRadioItem
									className="cursor-pointer"
									value="en"
									disabled={locale === "en"}
									onSelect={() => setLocale("en")}
								>
									<FormattedMessage
										defaultMessage="English"
										id="page.profile.settings.language.en"
									/>
								</DropdownMenuRadioItem>
							</DropdownMenuRadioGroup>
						</DropdownMenuGroup>
					</DropdownMenuContent>
				</DropdownMenu>
			</div>
		</header>
	);
}
